export default "__VITE_ASSET__BEMXP_pC__"